import { render, staticRenderFns } from "./BatteryCopy.vue?vue&type=template&id=4436bd60"
import script from "./BatteryCopy.vue?vue&type=script&lang=js"
export * from "./BatteryCopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports